import '../styles/index.scss';
import Swiper from 'swiper';
import 'swiper/css';

const getNodeIndex = elm => [...elm.parentNode.children].indexOf(elm)
new Swiper('.team .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    on: {
        init: (sw) => {

            if (sw.isBeginning) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 0;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            } else if (sw.isEnd) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 0;
            } else {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            }
        },
        slideChange: (sw) => {
            if (sw.isBeginning) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 0;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            } else if (sw.isEnd) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 0;
            } else {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            }
        }
    }
});
new Swiper('.news .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    on: {
        init: (sw) => {

            if (sw.isBeginning) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 0;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            } else if (sw.isEnd) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 0;
            } else {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            }
        },
        slideChange: (sw) => {
            if (sw.isBeginning) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 0;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            } else if (sw.isEnd) {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 0;
            } else {
                sw.el.parentElement.querySelector('.swiper-footer__prev').style.opacity = 1;
                sw.el.parentElement.querySelector('.swiper-footer__arrow').style.opacity = 1;
            }
        }
    }
});


document.querySelectorAll('.swiper-footer').forEach((item) => {
    item.querySelector('.swiper-footer__arrow').addEventListener('click', e => {
        e.preventDefault();
        const swiperParent = item.parentElement.querySelector('.swiper').swiper;
        swiperParent.slideNext();
    });
    item.querySelector('.swiper-footer__prev').addEventListener('click', e => {
        e.preventDefault();
        const swiperParent = item.parentElement.querySelector('.swiper').swiper;
        swiperParent.slidePrev();
    });
});

const heroSlide = document.querySelector('.hero__scroll');
if (heroSlide) {
    heroSlide.addEventListener('click', e => {
        e.preventDefault();
        document.querySelector('.lead').scrollIntoView({
            behavior: 'smooth'
        });
    });
}

document.querySelector('.header__button button').addEventListener('click', e => {
    e.preventDefault();

    const header =
        document.querySelector('.header');
    if (header.classList.contains('visible')) {
        header.classList.remove('visible');
    } else {
        header.classList.add('visible');
    }
});

const fillChild = (parent, color) => {
    parent.querySelectorAll('path').forEach(item => {
        item.style.fill = color;
    });
};

const showRegionChildren = (regionId) => {
    console.log(regionId);
    const region = window.arenas.find(r => r.id == regionId);
    region.items.forEach(item => {
        console.log(item);
        item.items.forEach(item2 => {
            const el = document.querySelector('[item-data-id="' + item2['id'] + '"]');
            if (el) {
                el.style.display = 'block';
            }
        });
    });
};

const hideRegionChildren = (regionId) => {
    console.log(regionId);
    const region = window.arenas.find(r => r.id == regionId);
    region.items.forEach(item => {
        item.items.forEach(item2 => {
            const el = document.querySelector('[item-data-id="' + item2['id'] + '"]');
            if (el) {
                el.style.display = 'none';
            }
        });
    });
};

// const continents = document.querySelectorAll('.north,.east,.central,.south,.west');
const showLocations = document.querySelectorAll('.-js-show-location');
const arenaItems = document.querySelectorAll('.-js-show-arena');
showLocations.forEach(item => {

    item.addEventListener('click', e => {
        e.preventDefault();

        showLocations.forEach(item2 => {
            if (item2 != item) {
                item2.parentElement.classList.remove('active');
            }
        });

        if (item.parentElement.classList.contains('active')) {
            item.parentElement.classList.remove('active');
        } else {
            item.parentElement.classList.add('active');
        }


        let found = false;
        showLocations.forEach(item_ => {
            if (item_.parentElement.classList.contains('active')) {
                fillChild(document.querySelector('#' + item_.getAttribute('data-key')), `rgb(${item_.getAttribute('data-color')})`);
                showRegionChildren(item_.getAttribute('data-id'));
                found = true;
            } else {
                fillChild(document.querySelector('#' + item_.getAttribute('data-key')), `#DADAE5`);
                hideRegionChildren(item_.getAttribute('data-id'));
            }
        });

        if (!found) {
            showLocations.forEach(item_ => {
                fillChild(document.querySelector('#' + item_.getAttribute('data-key')), `rgb(${item_.getAttribute('data-color')})`);
                showRegionChildren(item_.getAttribute('data-id'));
            });
        }


        arenaItems.forEach(item_ => {
            item_.classList.remove('active');
        });
        hidePlaceTooltip();
    });
});

var activeArena = 0;
const showPlaceTooltip = (arenaId) => {
    activeArena = arenaId;
    const arena = document.querySelector('[item-data-id="' + arenaId + '"]');
    let arenaObj = null;
    window.arenas.forEach(item => {
        item.items.forEach(item2 => {
            item2.items.forEach(item3 => {
                if (item3.id == +arenaId) {
                    arenaObj = item3;
                }
            });
        });
    });

    console.log(arenaObj);

    if (arenaObj == null) return;
    arena.querySelector('path[fill="#E73237"]').setAttribute('fill', '#5753b3');
    console.log(arena);
    const pp = document.querySelector('#pp');
    pp.classList.add('visible');
    document.querySelector('#pp_name').innerHTML = arenaObj.name;
    document.querySelector('#pp_location').innerHTML = arenaObj.city + ", " + arenaObj.country;
    document.querySelector('#pp_more').setAttribute('href', arenaObj.slug);
    document.querySelector('#pp_image').setAttribute('src', arenaObj.image);
    console.log(arena.getBoundingClientRect());
    pp.style.top = (arena.getBoundingClientRect().top - document.querySelector('.map__image').getBoundingClientRect().y) + 'px';
    const left = (arena.getBoundingClientRect().left - document.querySelector('.map__image').getBoundingClientRect().x);
    const fromX = document.querySelector('.map__image').getBoundingClientRect().x;
    const ppW = pp.clientWidth;
    const diffLeft = left + fromX + ppW;
    console.log(left, fromX, ppW, 100);
    console.log(diffLeft, window.innerWidth);
    if (diffLeft < window.innerWidth) {
        pp.style.left = left + 'px';
    } else {
        const diff = left + document.querySelector('.map__image').getBoundingClientRect().x + pp.clientWidth - window.innerWidth;
        console.log(diff);
        pp.style.left = (left - diff) + 'px';
    }

};

const hidePlaceTooltip = () => {
    if (activeArena == 0) return;
    const arena = document.querySelector('[item-data-id="' + activeArena + '"]');
    arena.querySelector('path[fill="#5753b3"]').setAttribute('fill', '#E73237');
    document.querySelector('#pp').classList.remove('visible');
    activeArena = 0;
};

arenaItems.forEach(item => {
    item.addEventListener('click', e => {
        if (!document.querySelector('.sub-hero')) {
            e.preventDefault();
        }
        arenaItems.forEach(item_ => {
            if (item_ != item) {
                item_.classList.remove('active');
            }
        });

        if (item.classList.contains('active')) {
            item.classList.remove('active');
            hidePlaceTooltip();
        } else {
            hidePlaceTooltip();
            item.classList.add('active');
            showPlaceTooltip(item.getAttribute('data-id'));

            if (window.innerWidth <= 900) {
                document.querySelector('.map__image').scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
    });
});

document.querySelectorAll('[item-data-id]').forEach(dot => {
    dot.addEventListener('click', e => {
        e.preventDefault();
        const id = +dot.getAttribute('item-data-id');
        if (!id || isNaN(id)) return;

        const item = document.querySelector('.-js-show-arena[data-id="' + id + '"]');

        arenaItems.forEach(item_ => {
            if (item_ != item) {
                item_.classList.remove('active');
            }
        });

        if (item.classList.contains('active')) {
            item.classList.remove('active');
            hidePlaceTooltip();
        } else {
            item.classList.add('active');
            hidePlaceTooltip();
            showPlaceTooltip(id);
        }
    });
});



document.querySelectorAll('.-js-show-kid').forEach(item => {
    item.addEventListener('click', e => {
        e.preventDefault();
        if (item.parentElement.classList.contains('active')) {
            item.parentElement.classList.remove('active');
        } else {
            item.parentElement.classList.add('active');
        }
    })
})

document.querySelector('.-js-map-button')?.addEventListener('click', e => {
    e.preventDefault();
    document.querySelector('.map-picker-holder').classList.remove('js-list');
    document.querySelector('.map-picker-holder').classList.add('js-map');
})
document.querySelector('.-js-list-button')?.addEventListener('click', e => {
    e.preventDefault();
    document.querySelector('.map-picker-holder').classList.remove('js-map');
    document.querySelector('.map-picker-holder').classList.add('js-list');
})

document.querySelectorAll('.pillar').forEach(item => {
    item.addEventListener('click', e => {
        const idx = getNodeIndex(item);
        document.querySelectorAll('.text-section h3')[idx].scrollIntoView({
            behavior: 'smooth'
        });
    })
})

document.querySelector('#pp_close')?.addEventListener('click', e => {
    e.preventDefault();
    hidePlaceTooltip();

    const item = document.querySelector('.-js-show-arena[data-id="' + activeArena + '"]');
    item.classList.remove('active');


});
